<template>
    <section>

        <b-collapse class="card has-background-transparent"
                    animation="slide"
                    :open="isOpen == 0"
                    @open="isOpen = 0">
            <template #trigger="props">
                <div
                    class="card-header has-background-light"
                    role="button">
                    <p class="card-header-title">
                        {{$t('MANUTENCAOLISTAR.PESSOAS')}}
                    </p>
                    <a class="card-header-icon">
                        <b-icon v-show="props.open" icon="chevron-up"></b-icon>
                        <b-icon v-show="!props.open" icon="chevron-down"></b-icon>
                    </a>
                </div>
            </template>
            <div class="card-content is-paddingless">
                <div class="columns">
             
                    <div  v-if="isInRole('funcionario-consultar') || isInRole('funcionario-alterar')" class="column ">
                        <div class="panel">
                            <p class="panel-heading background-1">
                                {{$t('MANUTENCAOLISTAR.FUNCIONARIO')}}
                            </p>
                            <form @submit.stop.prevent="$router.push({ name: 'funcionarios', query: { procurar: procurar.funcionario }})" method="get" class="panel-block">
                                <b-input :placeholder="$t('SISTEMA.PROCURAR')"
                                         v-model="procurar.funcionario"
                                         name="procurar" 
                                         icon="magnify"></b-input>
                            </form>                            
                            <div class="panel-block is-justified-between">
                                <router-link v-if="isInRole('funcionario-consultar')" :to="{ name: 'funcionarios' }" class="button is-light is-fullwidth">
                                    {{$t('SISTEMA.LISTARTODOS')}}
                                  </router-link>
                                <router-link v-if="isInRole('funcionario-alterar')" :to="{ name: 'funcionario' }" class="button is-link is-fullwidth">
                                    {{$t('SISTEMA.INCLUIR')}}
                                </router-link>
                            </div>
                        </div>
                    </div>                     
                     <div v-if="isInRole('Administrador')" class="column ">
                        <div   class="panel">
                            <p class="panel-heading background-2">
                                {{$t('MANUTENCAOLISTAR.NIVELACESSO')}}
                            </p>
                            <form @submit.stop.prevent="$router.push({ name: 'niveisdeacesso', query: { procurar: procurar.niveldeacesso }})" method="get" class="panel-block">
                                <b-input :placeholder="$t('SISTEMA.PROCURAR')"
                                         v-model="procurar.niveldeacesso"
                                         name="procurar" 
                                         icon="magnify"></b-input>
                            </form>
                            <div class="panel-block is-justified-between">
                                <router-link :to="{ name: 'niveisdeacesso' }" class="button is-light is-fullwidth">
                                    {{$t('SISTEMA.LISTARTODOS')}}
                                </router-link>
                                <router-link :to="{ name: 'niveldeacesso' }" class="button is-link is-fullwidth">
                                    {{$t('SISTEMA.INCLUIR')}}
                                </router-link>
                            </div>
                        </div>
                    </div>          
                    <div class="column ">
                    
                    </div>                      
                  
                                                  
                </div>
                 
            </div>
        </b-collapse>        

        <b-collapse class="card has-background-transparent"
                    animation="slide"
                    :open="isOpen == 2"
                    @open="isOpen = 2">
            <template #trigger="props">
                <div
                    class="card-header has-background-light"
                    role="button">
                    <p class="card-header-title">
                        {{$t('MANUTENCAOLISTAR.EMPRESA')}}
                    </p>
                    <a class="card-header-icon">
                        <b-icon v-show="props.open" icon="chevron-up"></b-icon>
                        <b-icon v-show="!props.open" icon="chevron-down"></b-icon>
                    </a>
                </div>
            </template>
            <div class="card-content is-paddingless">
                <div class="columns">
                    <div class="column">
                            <div v-if="isInRole('unidade-alterar') || isInRole('unidade-consultar') && isInRole('Administrador')" class="panel">
                                <p class="panel-heading background-1">
                                    {{$t('MANUTENCAOLISTAR.UNIDADES')}}
                                </p>
                                <form @submit.stop.prevent="$router.push({ name: 'unidades', query: { procurar: procurar.unidade }})" method="get" class="panel-block">
                                    <b-input :placeholder="$t('SISTEMA.PROCURAR')"
                                                v-model="procurar.unidade"
                                                name="procurar" 
                                                icon="magnify"></b-input>
                                </form>
                                <div class="panel-block is-justified-between">
                                    <router-link :to="{ name: 'unidades' }" class="button is-light is-fullwidth">
                                    {{$t('SISTEMA.LISTARTODOS')}}
                                    </router-link>
                                    <router-link v-if="isInRole('unidade-alterar')" :to="{ name: 'unidade' }" class="button is-link is-fullwidth">
                                        {{$t('SISTEMA.INCLUIR')}}
                                    </router-link>
                                </div>
                            </div>
                        </div>      
                    <div class="column">
                
                    </div>
                    <div class="column">                        
                
                    </div>
                    <div class="column">
                   
                    </div>                    
                </div>
            </div>
        </b-collapse>


    </section>
</template>

<script>
    import http from '@/http'
    import { mapState, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                isOpen: 0,
                procurar: {}
            }
        },
        computed: {
            ...mapGetters([
                'isInRole'
            ]),
            ...mapState([
                'config',
                'integradores',
                'usuario'   
            ])
        },
        methods: {
            loadTotalNotificacoesFuncionario() {
                
                http.get('/api/notificacao/retornaTotalNotificacoesFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                        this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO',data)
                    })
                    .catch((error) => {                        
                        throw error
                    });

                http.get('/api/notificacao/RetornaTotalMensagensFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                            this.$store.commit('componentes/SET_TOTAL_MENSAGENS',data)
                        
                    })
                    .catch((error) => {                        
                        throw error
                    });                      
                
            },             
        },
        mounted() {                        
            this.loadTotalNotificacoesFuncionario();                                                                      
        }        
    }
</script>
